import { apiRequest, ApiError } from './apiClient';
import { API_BASE_URL } from '../config/api';

const FILENAME_FROM_DISPOSITION = /filename="?([^";]+)"?/i;

export const downloadEmployeeImportTemplate = async () => {
  const response = await fetch(`${API_BASE_URL}/api/employees/profiles/import/template`, {
    credentials: 'include'
  });
  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new ApiError(payload.error || `Template download failed with status ${response.status}`, response.status, payload);
  }
  const disposition = response.headers.get('Content-Disposition') || '';
  const match = disposition.match(FILENAME_FROM_DISPOSITION);
  const filename = match ? match[1] : 'vizionops-employee-import-template.csv';
  const blob = await response.blob();
  return { blob, filename };
};

export const previewEmployeeImport = (csvText) => apiRequest('/api/employees/profiles/import/preview', {
  method: 'POST',
  body: JSON.stringify({ csvText })
});

export const commitEmployeeImport = ({ csvText, fingerprint }) => apiRequest('/api/employees/profiles/import/commit', {
  method: 'POST',
  body: JSON.stringify({ csvText, fingerprint })
});
